module.exports = __webpack_public_path__ + "assets/images/project/menu/malaysia-thumb.jpg?v=33d0c82a";